import { useQuery } from "@tanstack/react-query";
import { getDashboard } from "../api";

export function useDashboardHook({ token, role, userId, enabled = true }) {
  return useQuery({
    queryKey: ["dashboard", role, userId],
    enabled: enabled && !!token && !!role && !!userId,
    staleTime: 5 * 60 * 1000,
    gcTime: 30 * 60 * 1000,
    queryFn: async () => {
      const result = await getDashboard({ token, role });
      if (!result.ok) {
        throw new Error(result.error || "Unable to load dashboard data.");
      }
      return result.data;
    },
  });
}
